/* eslint-disable react/no-array-index-key */
import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { APIgetFilesList } from '../../api/Files';

import FilesGridItem from '../Files/GridItem';
import DashboardWidgetPlaceholderFile from './WidgetPlaceholderFile';
import DashboardWidgetSkeletonFile from './WidgetSkeletonFile';

import { getDashboardComponentSettings } from '../../helpers/Dashboard';

const DashboardWidgetFavoriteFiles = () => {
  const intl = useIntl();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const [rowHeight, setRowHeight] = useState(null);

  const containerRef = useRef(null);

  const componentSetting = getDashboardComponentSettings('favorite-files');
  const rowCount = componentSetting ? componentSetting.h : 1;

  const loadItems = useCallback((page = 1) => {
    APIgetFilesList({
      favorites: true,
      page,
      per_page: 8,
    }).then(response => {
      setItems(response.data.data);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    loadItems();
  }, [loadItems]);

  const handleChangeRowHeight = useCallback(() => {
    if (containerRef.current) {
      const computedStyle = window.getComputedStyle(containerRef.current);
      const gap = parseFloat(computedStyle.getPropertyValue('row-gap'));

      let firstChildHeight = 0;
      const firstChild = containerRef.current.firstElementChild;
      if (firstChild) {
        firstChildHeight = parseFloat(window.getComputedStyle(firstChild).getPropertyValue('height'));
      }

      setRowHeight((firstChildHeight * rowCount) + (gap * rowCount) - 1);
    }
  }, [rowCount]);

  useEffect(() => {
    handleChangeRowHeight();
  }, [handleChangeRowHeight]);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(handleChangeRowHeight);

    const dashboard = document.querySelector(`.dashboard-content`);

    resizeObserver.observe(dashboard);

    return () => {
      resizeObserver.unobserve(dashboard);
    };
  }, [handleChangeRowHeight]);

  return (
    <div className="dashboard-section">
      <div className="dashboard-section-title">
        <div>
          <h3>{intl.formatMessage({ defaultMessage: 'Favorite files' })}</h3>
          <Link to="/files">
            <span>{intl.formatMessage({ defaultMessage: 'See all' })}</span>
          </Link>
        </div>
      </div>
      <div className="dashboard-section-content">
        <div className="dashboard-section-favorite-files-wrapper files-grid" ref={containerRef} style={{ height: rowHeight || 'unset' }}>
          {!loading && items.map(f => (
            <FilesGridItem
              id={f.uuid}
              index={f.uuid}
              key={f.uuid}
              file={f}
              moveFile={null}
              saveFiles={() => {}}
              handleMoveSelectedItems={() => {}}
              isMoved={false}
              isSelected={false}
              onFileSelect={() => {}}
              allowCheck={false}
            />
          ))}
          {loading ?
            [...Array(18)].map((_, i) => <DashboardWidgetSkeletonFile key={i} />) :
            (items.length < 18 && items.length > 0) && [...Array(18 - items.length)].map((_, i) => <DashboardWidgetPlaceholderFile key={`dp-${i}`} />)}
          {(!loading && items.length === 0) && (
            <p className="dashboard-section-not-found-message">{intl.formatMessage({ defaultMessage: 'You don\'t have any favorite files yet' })}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardWidgetFavoriteFiles;
